import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import ClientScopedEmptyState from './ClientScopedEmptyState';
import { useClientScopedGate } from '../hooks/useClientScopedGate';

/**
 * Shows a loading spinner, activation empty state, or page children.
 * Use on read-only client-scoped pages (Reports, Analytics, ML Insights).
 * Do not wrap Posts, Scheduling, or Gallery — those are the work surfaces
 * the empty states link to.
 */
export default function ClientScopedGate({
  clientId,
  children,
  minHeight = 360,
  postsPrimaryTo = '/posts',
  requirePosts = true,
  acceptGsc = false,
  sx,
}) {
  const gate = useClientScopedGate({ clientId, requirePosts, acceptGsc });

  if (gate.loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight,
          ...sx,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (gate.variant) {
    return (
      <ClientScopedEmptyState
        variant={gate.variant}
        clientId={gate.clientId}
        postsPrimaryTo={postsPrimaryTo}
        sx={sx}
      />
    );
  }

  return children;
}
